<template>
  <div style="position: relative;height: 100%">
    <router-view v-if="systemConfig"/>
    <div class="rightPhone">

      <transition-group name="draw">   <!--这里的name 和 css 类名第一个字段要一样-->
        <div key="1">
          <div id="viscosity" @click="openBox" class="title" v-if="boxshow" @mouseenter="mouse=true"
               @mouseleave="mouse=false" :class="mouse ? 'mouse' :''" style="padding:10px 0">
            <p v-if="mouse"><img src="../static/img/jiantou-right.png"/></p>
            <p v-else><img src="../static/img/white-phone.png"/></p>
            <p>咨</p>
            <p>询</p>
            <p>公</p>
            <p>证</p>
            <p>处</p>
          </div>
          <div id="viscosityBox" v-if="!boxshow" style="display: flex">
            <!--            <div class="title" >-->
            <!--              <p><img src="../static/img/jiantou-right.png" style="transform: rotate(180deg);"></p>-->
            <!--            </div>-->
            <div class="box">
              <div class="top-box">
                <p class="p1">{{$store.getters.systemConfig.notaryName}}</p>
                <p>电话：{{$store.getters.systemConfig.notaryPhone}}</p>
                <p >地址：
                  {{$store.getters.systemConfig.notaryAddress}}</p>
              </div>
              <div style="text-align: center">
                <img :src="$store.getters.systemConfig.consultQrcodeUrl" style="width: 150px;height: 150px;"/>
                <p>{{$store.getters.systemConfig.consultText}}</p>
              </div>
            </div>

          </div>
        </div>
      </transition-group>

    </div>

    <div class="rightPhone " :style="{top:boxshow?'38%':'calc(38% + 200px)'}"
         v-if="systemConfig.indexStyle !==4 &&!token">

      <transition-group name="draw">   <!--这里的name 和 css 类名第一个字段要一样-->
        <div key="2">
          <div id="viscosity2" @click="openBox2" class="title title2" v-if="boxshow2" @mouseenter="mouse2=true"
               @mouseleave="mouse2=false" :class="mouse2 ? 'mouse' :''" style="padding:10px 0;box-sizing: border-box">
            <p v-if="mouse2"><img src="../static/img/jiantou-right.png"/></p>
            <p v-else><img src="../static/img/mobile.png"/></p>
            <p>移</p>
            <p>动</p>
            <p>端</p>
          </div>
          <div id="viscosityBox2" v-if="!boxshow2" style="display: flex">
            <div class="box1">
              <p class="p1">移动端</p>
              <img src="../static/img/mobile-qr.png" style="width: 120px;height: 120px;margin-top: 20px" alt="">
              <!--              <qrcode-vue :value="QrCode" level="H" class="qrCode"-->
              <!--                          style="margin-top: 10px;padding: 20px;background-color: #2C69EC;"></qrcode-vue>-->
            </div>

          </div>
        </div>
      </transition-group>

    </div>
  </div>
</template>

<script>
  import httpServer from './http/http-server'
  import store from './store/index'
  import QrcodeVue from 'qrcode.vue'
  import Vue from "vue";
  import {mapState} from "vuex";
  import config from './config';
  export default {
    name: 'App',
    components: {
      QrcodeVue
    },
    data() {
      return {
        boxshow: true,
        boxshow2: true,
        QrCode: '',
        mouse: false,
        mouse2: false,
        systemConfig: {},
      }
    },
    created() {
      this.QrCode = Vue.prototype.globalConfig.domain.mobile_front_url
      this.query()
      window.addEventListener('storage', event => {
      })
      console.log(123123123,config)
    },
    computed: {
      ...mapState(['token'])
    },
    methods: {
      enter() {
        this.mouse = true
        console.log(this.mouse, 'this.mouse')
      },
      openBox() {
        let callBack = (e) => {
          let viscosityBox = document.getElementById('viscosityBox')
          let viscosity = document.getElementById('viscosity')
          if (viscosityBox && !viscosity) {
            if (!viscosityBox.contains(e.target)) {
              document.removeEventListener('click', callBack)
              this.boxshow = true
            }
          }
        }
        setTimeout(() => {
          document.addEventListener('click', callBack)
        }, 0)
        this.boxshow = !this.boxshow
      },
      openBox2() {
        let callBack = (e) => {
          let viscosityBox = document.getElementById('viscosityBox2')
          let viscosity = document.getElementById('viscosity2')
          if (viscosityBox && !viscosity) {
            if (!viscosityBox.contains(e.target)) {
              document.removeEventListener('click', callBack)
              this.boxshow2 = true
            }
          }
        }
        setTimeout(() => {
          document.addEventListener('click', callBack)
        }, 0)
        this.boxshow2 = !this.boxshow2
      },
      query() {
        httpServer.systemConfigQuery().then(res => {
          if (res.success) {
            this.systemConfig = res.data
            store.commit('SET_SystemConfig', res.data)
            localStorage.setItem('systemConfig', JSON.stringify(res.data));

            console.log(this.$store.getters.systemConfig, 'this.$store.systemConfig3333')

          } else {
            store.commit('SET_SystemConfig', {})
          }
        })


      },


    }
  }
</script>
<style lang="less" scoped>
  .rightPhone {
    position: fixed;
    z-index: 999999;
    top: 12%;
    right: 0px;
    background: #fff;
    border-radius: 8px 0px 0px 8px;

    img {
      width: 18px;
      height: 18px;
    }

    .title {

      background: #2C69EC;
      border-radius: 4px 0px 0px 4px;
      font-size: 18px;
      color: #fff;
      width: 40px;
      height: 150px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
      text-align: center;
    }

    .title2 {
      height: 115px;
    }

    .box {
      border-radius: 8px 0px 0px 8px;

      /*height: 135px;*/
      width: 240px;
      right: 25px;
      font-size: 14px;
      text-align: left;
      box-shadow: 0px 2px 8px 0px rgba(191, 200, 225, 0.25);
      background: #2C69EC;
      /*background-color:black;*/

      .top-box {
        width: 150px;
        margin: 0 auto;
      }

      .p1 {
        font-size: 14px;
        color: #fff;
        /*height: 50px;*/
        /*line-height: 50px;*/
        text-align: left;
        font-weight: bold;
        // border: 1px dashed #042470;
      }

      p {
        color: #fff;
        margin: 15px 0px;
      }

    }

    .box1 {
      width: 160px;
      height: 200px;
      background: #2C69EC;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 8px 0 0 8px;

      .p1 {
        color: #fff;
      }
    }

    .draw-enter-active, .draw-leave-active {
      transition: opacity 0.5s linear;
    }

    .draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
      height: 0;
    }

    &:hover {
      cursor: pointer;
    }

    .mouse {
      background: #0844D2;
      border-radius: 4px 0px 0px 4px;

    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue